import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { styles } from './styles'

const TableHeader = ({ data }) => {
  return (
    <Row style={styles.row}>
      {data.map(item => (
        <Col xs={item.xs} style={styles.col(item.align)}>
          <div style={styles.contentWrapper}>
            <div style={styles.iconWrapper}>{item.icon}</div>
            <div style={styles.label}>{item.label}</div>
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default TableHeader
